import React from 'react'
import ReactDOM from 'react-dom'
import '../MovimientosAlmacen/Movimiento.css'
// import "../../componentes/styles/Modal.css";

function MovimientoModal (props) {
    if(!props.isOpen){
        return null
    }
    return ReactDOM.createPortal(
        <div className="abed_Modal d-flex align-items-center justify-content-center p-2" tabIndex='-1'>
                <div className="abed__Modal__container w-100 m-3" style={{maxWidth: '800px'}}>
                    <div className="abed__modal-header d-flex justify-content-between align-items-center p-3 border-bottom">
                        <h5 className="abed__modal-header-title m-0 fs-5">{props.title}</h5>
                        <button className="close btn btn-sm btn-outline-secondary p-1 px-2" onClick={props.onClose}>X</button>
                    </div>
                    <div className="modal-body bg-color p-3">
                        {props.children}
                    </div>
                    <div className="modal-footer bg-color-footer d-flex justify-content-end p-3 border-top">
                        {/* <button className="btn btn-secondary me-2" onClick={props.onClose}>Cancelar</button>
                        <button className="btn btn-primary" onClick={props.onSubmit} >Aceptar</button> */}
                    </div>
                </div>
        </div>
        ,
        
        document.getElementById('modal')
    );
}

export default MovimientoModal